import { planTypes } from '@/common/constants';
import { getPlanLogo } from '@/common/plan-logo-map';
import { enableCAICPlanRebranding } from '@/plans/ZOOM_CUSTOM_AI_COMPANION/utils.js';

export default {
  key: planTypes[planTypes.ZM_AI_COMPANION],
  data() {
    return {
      logo: getPlanLogo(planTypes.ZM_AI_COMPANION),
      title: window.$query?.referrer === 'mynotes' && !this.$context?.is?.edit
        ? this.$t('billing.my_notes.title')
        : (enableCAICPlanRebranding
          ? this.$t('billing.zoom_ai_companion.rebranding_title')
          : this.$t('billing.zoom_ai_companion.title')
        ),
      planType: planTypes.ZM_AI_COMPANION,
    };
  },
};
